import React from 'react'
import { ListGroupItem } from "react-bootstrap";
import { Link } from "gatsby";
import PaperSummary from "./paper-summary";


const Paper = ({node}) => {
    
    const { slug } = node.fields;
    const {title, date, jurnal, published, submitted, coauthor, doi, lecturefiles, links} = node.frontmatter;

    console.log("coauthor: ", coauthor);    

    return (
        <ListGroupItem >
            <Link to={slug || "/"}>
                <h4 className='paper-title'>{title}</h4>                
            </Link>
            <section className='paper-summary'>
            {
                <PaperSummary date={date} jurnal={jurnal} coauthor={coauthor} published={published}></PaperSummary>
            }    
            </section>
            {
                doi && <div className='link-container'><a href={doi}>{doi}</a></div>
            }                        
            <LectureFiles lecturefiles={lecturefiles} />            
            {
                links && <div className='link-container'><a href={links.href}>{links.label}</a></div>
            }
        </ListGroupItem>
    )
}

function isValidHttpUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (e) {
        return false;
    }
}

function LectureFiles({ lecturefiles }) {
    if (!lecturefiles) return null;

    const files = (Array.isArray(lecturefiles)
        ? lecturefiles
        : [lecturefiles]
    ).filter((file) => {
        return typeof file === "string" && isValidHttpUrl(file);
    });

    if (files.length === 0) return null;

    return (
        <div className='link-container'>
            {files.map((file) => (
                <div key={file}>
                    <a href={file} target="_blank" rel="noopener noreferrer">
                        {file}
                    </a>
                </div>
            ))}
        </div>
    );
}

export default Paper
